/* @flow */

import React from 'react';
import { graphql } from 'react-apollo';
import type { QueryProps } from 'react-apollo';

import { EVENT_COUNT_LIMIT } from '../events-footer/index';
import pastEventsQuery from './past.gql';
import PastEvents from './layouts/past';

type Props = {
  data: ProfileQuery & ProfilePastEventsQuery & QueryProps
};
type State = {
  currentPage: number
};

const withGraphqlQuery = graphql(pastEventsQuery, {
  options: (props: Object) => {
    const userPath = props.match.params.userPath;

    return {
      variables: {
        slug: userPath.substring(userPath.lastIndexOf('-') + 1),
        limit: EVENT_COUNT_LIMIT,
        offset: 0
      }
    };
  },
  props: ({ data, ownProps }: Object): Props => {
    return {
      ...ownProps,
      data: {
        ...data,
        profile: ownProps.data.profile
      }
    };
  }
});

class PastEventsContainer extends React.Component<void, Props, State> {
  state: State = { currentPage: 1 };

  render() {
    const { currentPage } = this.state;
    const newProps = {
      currentPage,
      changePage: this.changePage.bind(this),
      ...this.props
    };

    return <PastEvents {...newProps} />;
  }

  changePage({ selected }: { selected: number }): void {
    this.props.data.fetchMore({
      variables: {
        limit: EVENT_COUNT_LIMIT,
        offset: EVENT_COUNT_LIMIT * selected
      },
      updateQuery: (prev, { fetchMoreResult }) => (fetchMoreResult ? fetchMoreResult : prev)
    });
    this.setState({ currentPage: selected + 1 });
  }
}

export default withGraphqlQuery(PastEventsContainer);



// WEBPACK FOOTER //
// ./src/components/profile/events/past.js